import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import GoodThing from './goodThing';
import BusinessOperate from './businessOperate';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { globalGoodThing, productsRecommend, operateList } = content;
        const goodThing = {
            globalGoodThing,
            productsRecommend,
        };

        return (
            <div className={styles.rightContent}>
                <GoodThing content={goodThing} />
                <Chip id="230205" type="struct" title="商品运营" groupName="右边侧栏" content={operateList}>
                    <BusinessOperate content={operateList} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(RightContent);
